<template>
  <div class="workflow-record-list">
    <el-timeline reverse>
      <template v-for="(item, i) in list">
        <el-timeline-item
          v-if="Number(item.handleStatus) === 2"
          :key="'r-' + i"
          :timestamp="formatTime(item.handleTime)"
          placement="top"
        >
          <el-card shadow="never" class="record-card">
            <p class="timeline-cell">发起人：{{ emptyText(item.userName) }}</p>
          </el-card>
        </el-timeline-item>

        <el-timeline-item
          v-else-if="Number(item.handleStatus) === 3"
          :key="'r-' + i"
          :timestamp="formatTime(item.handleTime)"
          placement="top"
        >
          <el-card shadow="never" class="record-card">
            <p class="timeline-cell">撤回节点：{{ emptyText(item.nodeName) }}</p>
            <p class="timeline-cell">撤回人员：{{ emptyText(item.userName) }}</p>
            <p class="timeline-cell">撤回原因：{{ emptyText(item.handleOpinion) }}</p>
          </el-card>
        </el-timeline-item>

        <el-timeline-item
          v-else-if="Number(item.handleStatus) === 4"
          :key="'r-' + i"
          :timestamp="formatTime(item.handleTime)"
          placement="top"
        >
          <el-card shadow="never" class="record-card">
            <div class="record-card__head">
              <p class="timeline-cell">审核节点：{{ emptyText(item.nodeName) }}</p>
              <el-link :underline="false" type="danger">流程终止</el-link>
            </div>
            <p class="timeline-cell">执行人员：{{ emptyText(item.userName) }}</p>
            <p class="timeline-cell">执行动作：终止</p>
            <p class="timeline-cell">终止原因：{{ emptyText(item.handleOpinion) }}</p>
          </el-card>
        </el-timeline-item>

        <el-timeline-item
          v-else-if="Number(item.handleStatus) === 5"
          :key="'r-' + i"
          :timestamp="formatTime(item.handleTime)"
          placement="top"
        >
          <el-card shadow="never" class="record-card">
            <div class="record-card__head">
              <p class="timeline-cell">审核节点：{{ emptyText(item.nodeName) }}</p>
              <el-link :underline="false" type="primary">流程指派</el-link>
            </div>
            <p class="timeline-cell">执行人员：{{ emptyText(item.userName) }}</p>
            <p class="timeline-cell">执行动作：指派</p>
            <p class="timeline-cell">指派人员：{{ emptyText(item.operatorId) }}</p>
          </el-card>
        </el-timeline-item>

        <el-timeline-item
          v-else-if="Number(item.handleStatus) === 6"
          :key="'r-' + i"
          :timestamp="formatTime(item.handleTime)"
          placement="top"
        >
          <el-card shadow="never" class="record-card">
            <div class="record-card__head">
              <p class="timeline-cell">审核节点：{{ emptyText(item.nodeName) }}</p>
              <el-link :underline="false" type="primary">流程加签</el-link>
            </div>
            <p class="timeline-cell">执行人员：{{ emptyText(item.userName) }}</p>
            <p class="timeline-cell">执行动作：加签</p>
            <p class="timeline-cell">加签人员：{{ emptyText(item.operatorId) }}</p>
          </el-card>
        </el-timeline-item>

        <el-timeline-item
          v-else-if="Number(item.handleStatus) === 7"
          :key="'r-' + i"
          :timestamp="formatTime(item.handleTime)"
          placement="top"
        >
          <el-card shadow="never" class="record-card">
            <div class="record-card__head">
              <p class="timeline-cell">审核节点：{{ emptyText(item.nodeName) }}</p>
              <el-link :underline="false" type="primary">流程转办</el-link>
            </div>
            <p class="timeline-cell">执行人员：{{ emptyText(item.userName) }}</p>
            <p class="timeline-cell">执行动作：转办</p>
            <p class="timeline-cell">转办人员：{{ emptyText(item.operatorId) }}</p>
          </el-card>
        </el-timeline-item>

        <el-timeline-item
          v-else
          :key="'r-' + i"
          :timestamp="formatTime(item.handleTime)"
          placement="top"
        >
          <el-card shadow="never" class="record-card">
            <div class="record-card__head">
              <p class="timeline-cell">审核节点：{{ emptyText(item.nodeName) }}</p>
              <el-link v-if="Number(item.handleStatus) === 1" :underline="false" type="success">审核通过</el-link>
              <el-link v-else :underline="false" type="danger">审核拒绝</el-link>
            </div>
            <p class="timeline-cell">
              审核人员：{{ emptyText(item.userName) }}{{ Number(item.status) === 1 ? '(加签)' : '' }}
            </p>
            <p v-if="item.handleOpinion" class="timeline-cell">审核意见：{{ item.handleOpinion }}</p>
            <p v-if="item.signImg" class="timeline-cell">
              审核签名：<img :src="item.signImg" class="sign-img" alt="签名">
            </p>
          </el-card>
        </el-timeline-item>
      </template>

      <el-timeline-item v-if="endTime" :timestamp="formatTime(endTime)" placement="top">
        <el-card shadow="never" class="record-card">
          <p class="timeline-cell">流程结束</p>
        </el-card>
      </el-timeline-item>
    </el-timeline>
    <div v-if="!list.length && !endTime" class="empty-tip">暂无流转记录</div>
  </div>
</template>

<script>
export default {
  name: 'WorkflowRecordList',
  props: {
    list: { type: Array, default: () => [] },
    endTime: { type: [Number, String, Date], default: 0 }
  },
  methods: {
    emptyText(val) {
      if (val === undefined || val === null || String(val).trim() === '') return '无'
      return val
    },
    formatTime(val) {
      if (!val) return ''
      const d = new Date(val)
      if (isNaN(d.getTime())) return String(val)
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    }
  }
}
</script>

<style lang="scss" scoped>
.workflow-record-list {
  padding: 4px 8px 12px;
  max-width: 860px;
}
.record-card {
  border-radius: 10px;
  border: 1px solid #ebeef5;
}
.record-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 2px;
}
.timeline-cell {
  margin: 0 0 6px;
  font-size: 13px;
  color: #303133;
  line-height: 1.5;
  &:last-child { margin-bottom: 0; }
}
.sign-img {
  max-width: 160px;
  max-height: 60px;
  vertical-align: middle;
}
.empty-tip {
  padding: 24px 0;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
}
</style>
